import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";

import Login from "./components/Login";
import Home from "./pages/Home";
import Orders from "./pages/Orders";
import Reports from "./pages/Reports";
import Customers from "./pages/Customers";
import Credits from "./pages/Credits";
import Notes from "./pages/Notes";
import ProductPermission from "./pages/productsPermission";
import Maropost from "./pages/Maropost";
import Memberloginlogs from "./pages/memberLoginLogs";
import AdvancedSearch from "./pages/AdvancedSearch";
import ServicesSection from "./pages/Services";
import DirectPurchaseLink from "./pages/DirectPurchaseLink";
import DigitalReportsLink from "./pages/DigitalReportsLink";
import LeadTracking from "./pages/LeadTracking";
import ProtectedRoutes from "./services/ProtectedRoutes";
import AuthService from "./services/authService";
import AuthVerify from "./services/authVerify";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
  }

  logOut() {
    AuthService.logout();
  }

  render() {
    return (
      <div className="container">
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route exact path="*" element={<Login />} />
          <Route exact path="/" element={<ProtectedRoutes />}>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/:email" element={<Home />} />
            <Route exact path="/customers" element={<Home />} />
            <Route exact path="/customers/:email" element={<Customers />} />
            <Route exact path="/orders" element={<Home />} />
            <Route exact path="/orders/:email" element={<Orders />} />
            <Route exact path="/credits" element={<Home />} />
            <Route exact path="/credits/:email" element={<Credits />} />
            <Route exact path="/notes" element={<Home />} />
            <Route exact path="/notes/:email" element={<Notes />} />
            <Route exact path="/productpermission" element={<Home />} />
            <Route
              exact
              path="/productpermission/:email"
              element={<ProductPermission />}
            />
            <Route exact path="/maropost" element={<Home />} />
            <Route exact path="/maropost/:email" element={<Maropost />} />
            <Route exact path="/reports" element={<Home />} />
            <Route exact path="/reports/:email" element={<Reports />} />
            <Route
              exact
              path="/memberloginlogs/:email"
              element={<Memberloginlogs />}
            />
            <Route exact path="/advancedsearch" element={<AdvancedSearch />} />
            <Route
              exact
              path="/advancedsearch/:email"
              element={<AdvancedSearch />}
            />
            <Route exact path="/services" element={<ServicesSection />} />
            <Route
              exact
              path="/services/:email"
              element={<ServicesSection />}
            />
            <Route
              exact
              path="/directpurchaselink"
              element={<DirectPurchaseLink />}
            />
            <Route
              exact
              path="/directpurchaselink/:email"
              element={<DirectPurchaseLink />}
            />
            <Route
              exact
              path="/digitalreportslink"
              element={<DigitalReportsLink />}
            />
            <Route
              exact
              path="/digitalreportslink/:email"
              element={<DigitalReportsLink />}
            />
            <Route exact path="/leadtrackingdata" element={<Home />} />
            <Route
              exact
              path="/leadtrackingdata/:email"
              element={<LeadTracking />}
            />
          </Route>
        </Routes>
        <AuthVerify logOut={this.logOut} />
      </div>
    );
  }
}

export default App;
